import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";
import { QuestionCircleFill } from "react-bootstrap-icons";

export const QuestionModal = ({
  title,
  question,
  children,
  handleOk,
  handleClose,
}) => (
  <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title className="d-flex">
        <QuestionCircleFill className="align-self-center me-2 text-info" />
        <span>{title}</span>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>{question}</div>
      <div>{children}</div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        <FormattedMessage id="component.common.modal.button.no" />
      </Button>
      <Button variant="primary" onClick={handleOk}>
        <FormattedMessage id="component.common.modal.button.yes" />
      </Button>
    </Modal.Footer>
  </Modal>
);

QuestionModal.propTypes = {
  title: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  children: PropTypes.element,
  handleOk: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
